import { ASSETS_BASE_URL } from 'src/api/concierge';

export const CARD_BACKGROUND_URL = `${ASSETS_BASE_URL}/images/alumni-card.jpg`;
